<template>
  <div>
    <div class="d-block K2Input">
      <el-date-picker v-bind:value="value" v-on:input="handleInput" type="date" :placeholder="placeholder"> </el-date-picker>
    </div>
  </div>
</template>

<script>
export default {
  name: 'K2DatePicker',
  components: {},
  props: ['value', 'passPlaceholder'],
  watch: {
    passPlaceholder: function (val) {
      // watch it
      if (val) {
        this.placeholder = val
      }
    },
  },
  data() {
    return {
      placeholder: 'Select a date',
    }
  },
  methods: {
    handleInput(event) {
      console.log(event, 'event')
      this.$emit('input', event)
      this.$forceUpdate()
    },
  },
}
</script>
